


// Функция для расчета итоговой суммы
export const calculateTotal = (amountVal, taxVal, paymentTypeVal) => {
    try {
        // Преобразуем значения к числам
        const amountNum = Number(amountVal) || 0;
        const taxNum = Number(taxVal) || 21;
        const isCashPayment = Boolean(paymentTypeVal);

        if (amountNum <= 0) return 0;
        if (isCashPayment) return amountNum;

        return amountNum + (amountNum * taxNum) / 100;
    } catch (error) {
        return 0;
    }
};